/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Action handler function type
 */
export interface ActionHandler {
  (...args: any[]): any | Promise<any>;
}

/**
 * Action definition
 */
export interface Action extends ActionMetadata {
  handler: ActionHandler;
}

export enum ENUM_STATUS {
  SUCCEEDED = 'succeed',
  FAILED = 'failed',
}

export enum ENUM_PHASE {
  Trigger = 'trigger',
  Action = 'action',
}

export enum ENUM_ENV {
  DEV = 'development',
  PROD = 'production',
}

export interface ActionContext {
  attributes: {
    trigger: string;
    triggerID?: string;
    triggerType?: string;
    instanceID: string;
    status?: ENUM_STATUS;
    phase?: ENUM_PHASE;
    startAt?: number;
    endAt?: number;
    duration_ms?: number;
  };
  content?: string; // '{ input: {}, output: {} }'
}


export type TLogContent = string; // stringified { input, output }
export interface ILogAttributes {
  trigger?: string;
  trigger_id?: string;
  trigger_type?: string;
  instance_id?: string;
  status?: ENUM_STATUS;
  phase?: ENUM_PHASE;
  start_at?: number;
  end_at?: number;
  duration_ms?: number;
}

/**
 * Action metadata (without handler)
 */
export interface ActionMetadata {
  name?: string;
  path?: string;
  desc?: string;
}

/**
 * Logger interface for client SDK
 */
export interface Logger {
  debug(message: string, extra?: any): void;
  info(message: string, extra?: any): void;
  warn(message: string, extra?: any): void;
  error(message: string, extra?: any): void;
}

/**
 * TriggerClient configuration options
 */
export interface TriggerClientOptions {
  /**
   * Timeout for action execution (ms)
   */
  timeout?: number;
  imports?: any[];
}

export enum ENUM_ERROR {
  NOT_EXIST = 'NOT_EXIST',
  TIMEOUT = 'TIMEOUT',
  PARAM_INVALID = 'PARAM_INVALID',
  TRY_CATCH = 'TRY_CATCH',
}

export interface ILogContentParsed {
  /** 触发器名称 (例如 'cron-daily') */
  trigger?: string;
  /** 触发器定义 ID */
  trigger_id?: string;
  /** 触发器类型 (例如 定时任务、记录变更) */
  trigger_type?: string;
  /** 执行实例 ID */
  instance_id?: string;
  /** 阶段：触发阶段或动作执行阶段 */
  phase?: ENUM_PHASE;
  /** 状态：成功或失败 */
  status?: ENUM_STATUS;
  /** 执行耗时 (毫秒)。计算逻辑：(endAt - startAt) 或内部计时器 */
  duration_ms?: number;
  /** 核心内容 */
  content?: {
    /** 动作入参 */
    input?: any;
    /** 动作出参 */
    output?: any;
  };
  /** 错误信息，仅在 status 为 failed 时填充，否则为空字符串 */
  error_message?: string;
}
